<template>
  <div class="done-column p-3">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <h3 class="column-title m-0">
        <i class="fas fa-check-double text-success me-2"></i>Done
      </h3>
      <span class="badge bg-success rounded-pill">{{ DoneTasks.length }}</span>
    </div>

    <div class="task-card mb-3 p-3" v-for="(doneTask, index) in DoneTasks" :key="index">
      <div class="user-assignment d-flex align-items-center mb-3">
        <div class="avatar-wrapper">
          <div class="avatar-main shadow-sm">
            <img v-if="doneTask.assigned_profile || doneTask.creator_profile" 
                 :src="doneTask.assigned_profile || doneTask.creator_profile" 
                 alt="User Profile" 
                 class="avatar-img">
            <div v-else class="avatar-placeholder">
              {{ (doneTask.assigned_name || doneTask.username || 'U').charAt(0).toUpperCase() }}
            </div>
          </div>
          <div class="status-dot"></div>
        </div>

        <div class="user-details ms-3">
          <p class="user-name m-0">{{ doneTask.assigned_name || doneTask.username || 'Personal Task' }}</p>
          <small class="user-role">{{ doneTask.assigned_name ? 'Assigned to' : 'Task Owner' }}</small>
        </div>
      </div>

      <div class="task-body mb-3">
        <h5 class="task-title">{{ doneTask.title }}</h5>
        <div class="task-meta d-flex align-items-center text-success">
          <i class="far fa-calendar-check me-2"></i>
          <span>{{ doneTask.start_date ? formatDate(doneTask.start_date) : formatDate(doneTask.created_at) }}</span>
        </div>
      </div>

      <div class="task-actions d-flex justify-content-end border-top pt-2">
        <button class="btn-action view-btn" @click="$emit('show-detail', doneTask)" title="View Details">
           <i class="fas fa-comment"></i>
        </button>
        <button class="btn-action delete-btn" @click="$emit('delete-task', doneTask.id, doneTask.status)" title="Delete Task">
          <i class="fas fa-trash-alt"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["DoneTasks"],
  name: "DoneColumn",
  methods: {
    formatDate(dateString) {
      if (!dateString) return "N/A";
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
  }
}
</script>

<style scoped lang="scss">
// Custom Variables for consistency
$success-color: #28a745;
$card-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
$hover-shadow: 0 8px 24px rgba(40, 167, 69, 0.15);

.done-column {
  background-color: #f8f9fa;
  border-radius: 15px;
  min-height: 200px;
}

.column-title {
  font-weight: 800;
  color: #333;
  font-size: 1.25rem;
  letter-spacing: -0.5px;
}

.task-card {
  background: #ffffff;
  border: 1px solid rgba(0,0,0,0.05);
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    box-shadow: $hover-shadow;
    border-color: rgba($success-color, 0.3);
  }

  // Left colored strip
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background-color: $success-color;
  }
}

.avatar-wrapper {
  position: relative;
  
  .avatar-main {
    width: 42px;
    height: 42px;
    border-radius: 12px; // Modern squircle shape
    overflow: hidden;
    border: 2px solid #fff;
    background: #e9ecef;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar-placeholder {
    font-weight: bold;
    color: #495057;
    font-size: 1.1rem;
  }

  .status-dot {
    position: absolute;
    bottom: -2px;
    right: -2px;
    width: 12px;
    height: 12px;
    background-color: $success-color;
    border: 2px solid #fff;
    border-radius: 50%;
  }
}

.user-name {
  font-weight: 700;
  font-size: 0.9rem;
  color: #2d3436;
}

.user-role {
  font-size: 0.75rem;
  color: #636e72;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.task-title {
  font-weight: 600;
  font-size: 1.1rem;
  color: #1e272e;
  margin-bottom: 8px;
}

.task-meta {
  font-size: 0.85rem;
  background: rgba($success-color, 0.08);
  display: inline-flex;
  padding: 4px 12px;
  border-radius: 20px;
}

.btn-action {
  border: none;
  background: transparent;
  padding: 8px;
  margin-left: 8px;
  border-radius: 8px;
  transition: all 0.2s;
  
  &.view-btn {
    color: #0984e3;
    &:hover { background: #e1f5fe; }
  }
  
  &.delete-btn {
    color: #d63031;
    &:hover { background: #fff5f5; }
  }
}
</style>